<template>
    <label v-if="label">{{ label }}:</label>
    <input
            :name="name"
            :value="modelValue"
            v-bind="$attrs"
            @input="$emit('update:modelValue', $event.target.value)"
            class="field"
    >
</template>

<script>
	export default {
	    name: 'BaseInput',
		props: {
			label: String,
            name: String,
			modelValue: [String, Number]
		}
	}
</script>

<style lang="scss" scoped>
    label {
        display: block;
        font-weight: 700;
        margin-bottom: .3em;
    }

    input {
        display: block;
        width: 100%;
        padding: 1.3em;
        outline: 0;
        border: 2px solid var(--colorInputBorder);
        font-family: inherit;
        background: transparent;
        border-radius: 0;

        &[type=number] {
            display: inline-block;
            width: 8em;
            @media(max-width: 500px) {
                width: 100%;
                display: block;
            }
        }
    }
</style>
